export enum Channel {
  EMail = 'EMail',
  WhatsApp = 'WhatsApp',
  Phone = 'Phone',
}
